import { Button, Form } from "antd";
import React, {useState} from "react";
import {CloseCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {api} from "@redux/api";
import moment from "moment";
import DatePicker from "@components/ResponsiveDatePicker";

export const StationTemperatureFilters = (props) => {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [year, setYear] = useState(null);
    const [month, setMonth] = useState(null);
    const [loading, setLoading] = useState(false);
    const formRef = React.useRef()


    function handleSubmit(e) {
        console.log('submit', e)
        props.handleFilter(e)
    }

    const startDateFilter = () => {
        return (
            <DatePicker
                allowClear
                placeholder="Start Date"
                value={startDate}
                getPopupContainer={trigger => trigger.parentNode}
                onChange={setStartDate}
            />
        )
    }

    const endDateFilter = () => {
        return (
            <DatePicker
                allowClear
                placeholder="End Date"
                value={endDate}
                getPopupContainer={trigger => trigger.parentNode}
                onChange={setEndDate}
            />
        )
    }

    function handleClearButtonClick() {
        formRef.current.setFieldsValue({
            startDate: null,
            endDate: null,
        })
        props.handleClearButtonClick();
    }

    function handleRunFlow() {
        const yearPicker = moment(year).format('YYYY');
        const monthPicker = moment(month).format('M');
        setLoading(true);
        api.run_station_playwright(yearPicker.toString(), monthPicker.toString()).then(
            response => {
                // console.log('create', response);
                props.handleRefresh();
                setLoading(false);
                return response.data
            }
        ).catch(error => {
            setLoading(false);
        });
    }

    return <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        <Form
            id="form_filter"
            layout="inline"
            onFinish={handleSubmit}
            ref={formRef}
            style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
                        autoComplete="off">
            <Form.Item name={'startDate'} style={{ marginBottom: 0, width: 180 }}>
                {startDateFilter()}
            </Form.Item>

            <Form.Item name={'endDate'} style={{ marginBottom: 0, width: 180 }}>
                {endDateFilter()}
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
                <div style={{ display: 'flex', gap: 8 }}>
                    <Button type="primary" icon={<QuestionCircleOutlined/>} htmlType="submit">Query</Button>
                    <Button icon={<CloseCircleOutlined/>} onClick={handleClearButtonClick}>Clear</Button>
                </div>
            </Form.Item>
        </Form>

        <Form
            id="form_filter_run"
            layout="inline"
            ref={formRef}
            style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
                        autoComplete="off">
            <Form.Item name={'Year'} style={{ marginBottom: 0, width: 140 }}>
                <DatePicker
                    allowClear
                    placeholder="Year"
                    picker={'year'}
                    value={year}
                    getPopupContainer={trigger => trigger.parentNode}
                    onChange={setYear}
                />
            </Form.Item>

            <Form.Item name={'Month'} style={{ marginBottom: 0, width: 140 }}>
                <DatePicker
                    allowClear
                    placeholder="Month"
                    value={month}
                    picker={'month'}
                    getPopupContainer={trigger => trigger.parentNode}
                    onChange={setMonth}
                />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
                <Button type="primary" loading={loading} icon={<i className="fas fa-laptop-code pr-3"></i>} onClick={handleRunFlow}>Run Flow</Button>
            </Form.Item>
        </Form>
    </div>

}
